/* Progressive enhancement: navigation and learning links work without JavaScript. */
(() => {
  if (window.SeoulRootJourneyLoaded) return;
  window.SeoulRootJourneyLoaded = true;
  const header = document.querySelector('[data-sr-header]');
  function closeMenus(restore = false) {
    if (!header) return;
    const mobile = header.querySelector('.sr-mobile-nav');
    const active = mobile?.open ? mobile : header.querySelector('.sr-shop-menu[open]');
    header.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
    if (restore) active?.querySelector('summary')?.focus();
  }
  const mobileMenu = header?.querySelector('.sr-mobile-nav');
  mobileMenu?.addEventListener('toggle', () => {
    const trigger = mobileMenu.querySelector('summary');
    trigger.setAttribute('aria-label', mobileMenu.open ? 'Dismiss navigation menu' : 'Open navigation menu');
    trigger.setAttribute('aria-expanded', String(mobileMenu.open));
  });
  header?.addEventListener('click', e => {
    if (e.target.closest('[data-sr-menu-backdrop]')) closeMenus(true);
    else if (e.target.closest('a')) closeMenus();
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeMenus(true);
    if (e.key === 'Tab' && mobileMenu?.open) {
      const stops = [...mobileMenu.querySelectorAll('summary, a[href]')];
      const first = stops[0], last = stops[stops.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('click', e => { if (header && !header.contains(e.target)) closeMenus(); });
  header?.addEventListener('focusout', () => setTimeout(() => { if (!header.contains(document.activeElement)) closeMenus(); }, 0));
  matchMedia('(min-width: 1201px)').addEventListener('change', () => closeMenus());
  document.addEventListener('click', e => {
    const anchor = e.target.closest('a[href]');
    if (anchor) {
      const url = new URL(anchor.href, location.origin);
      if (url.origin === location.origin && url.pathname === location.pathname && url.hash) {
        const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (target?.matches('details')) target.open = true;
      }
    }
    const link = e.target.closest('[data-sr-journey]');
    if (link) window.SeoulRootAnalytics?.send('sr_journey_select', {sr_detail: link.dataset.srJourney});
  });
  function revealAnchor() {
    const id = decodeURIComponent(location.hash.slice(1));
    if (!id) return;
    const target = document.getElementById(id);
    if (target?.matches('details')) target.open = true;
  }
  window.addEventListener('hashchange', revealAnchor);
  revealAnchor();
  // Reading progress requires visible time as well as reaching the end, and never bypasses consent.
  const article = document.querySelector('[data-sr-guide]');
  if (article && 'IntersectionObserver' in window) {
    let activeSeconds = 0, inView = false, sent = false;
    const end = article.querySelector('[data-sr-guide-end]');
    if (end) {
      const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; }, {threshold: 0.2});
      observer.observe(end);
      const timer = setInterval(() => {
        if (document.visibilityState === 'visible') activeSeconds++;
        if (!sent && activeSeconds >= 30 && inView) {
          sent = window.SeoulRootAnalytics?.send('sr_guide_complete', {sr_detail: article.dataset.srGuide}) === true;
          if (sent) { clearInterval(timer); observer.disconnect(); }
        }
      }, 1000);
      window.addEventListener('pagehide', () => { clearInterval(timer); observer.disconnect(); }, {once: true});
    }
  }
})();
